<template>
  <div class="anouncemnet-show">
    <div id="div-with-loading5" class="vs-con-loading__container">
      <Spin size="large" fix v-if="loading"></Spin>
      <Row class="row" style="padding-top: 0">
        <Row class="title">{{ detail.title }}</Row>
        <Row algin="center" justify="space-between" type="flex">
          <div>
            <span class="text mr-32" v-if="detail.employee">
              {{ $t('announcement.text1') }}：{{ detail.publisher }}
            </span>
            <span class="text">
              {{ $moment(`${detail.publishAt}Z`).format('YYYY-MM-DD HH:mm') }}
            </span>
          </div>
        </Row>
      </Row>
      <div class="html" v-html="detail.content"></div>

      <div
        class="files-container"
        v-if="detail.policyAttachments && detail.policyAttachments.length > 0"
      >
        <Row class="title text-l">{{ $t('announcement.text4') }}：</Row>
        <Row type="flex">
          <Row
            v-for="(v, i) in detail.policyAttachments"
            :key="i"
            align="middle"
            type="flex"
            class="item cur-p"
            @click.native="download(v.key, v.name)"
          >
            <img
              src="../../../assets/img/icon_file.png"
              style="width: 48px; height: 48px"
              alt
            />
            <div class="detail">
              <div class="name text-hide">{{ v.name }}</div>
              <div class="size">{{ (v.size / 1024).toFixed(2) }} KB</div>
            </div>
          </Row>
        </Row>
      </div>
    </div>
    <OaExportPercent ref="oa_export_percent"></OaExportPercent>
  </div>
</template>
<script>
import OaExportPercent from '@/components/oa_export_percent';

export default {
  components: {
    OaExportPercent
  },
  data() {
    return {
      loading: false,
      detail: {}
    };
  },
  mounted() {
    this.init_data();
  },
  methods: {
    async init_data() {
      try {
        this.loading = true;
        const res = await this.$http(
          'get',
          `mobile/policies/${this.$route.params.id}`,
          {},
          true
        );
        this.detail = res.data;
        console.log(res);
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    download(key, fileName) {
      this.$refs['oa_export_percent'].download(key, fileName);
    }
  }
};
</script>
<style lang="less" scoped>
.anouncemnet-show {
  padding: 37px 16px;
}

.files-container {
  .title {
    font-size: 18px;
    font-weight: 500;
    color: #1f2329;
    line-height: 25px;
    margin-bottom: 15px;
  }

  .item {
    width: 235px;
    height: 80px;
    background: #f8f9fa;
    border-radius: 6px;
    padding: 0 19px;
    margin-right: 20px;

    .detail {
      margin-left: 12px;
      text-align: left;
      width: 65%;

      .name {
        font-size: 16px;
        font-weight: 400;
        color: #1f2329;
        line-height: 22px;
        margin-bottom: 6px;
      }

      .size {
        padding: 0;
        font-size: 12px;
        color: #858d99;
        line-height: 14px;
      }
    }
  }
}

.html {
  padding: 40px 0;
  font-size: 16px;
  color: #51565d;
  line-height: 26px;
  text-align: left;
}

.row {
  box-shadow: 0px 1px 0px 0px #dee0e3;
  padding-bottom: 20px;
  text-align: left;

  .title {
    font-size: 28px;
    font-weight: 500;
    color: #1f2329;
    line-height: 25px;
    margin-bottom: 14px;
  }

  .mr-32 {
    margin-right: 32px;
  }

  .ml_r-10 {
    margin: 0 10px;
    color: #858d99;
  }

  .text {
    font-size: 14px;
    color: #858d99;
    line-height: 16px;
  }
}
</style>
